export default function useAsset(assetPath: string): string {
  return `${process.env.BASE_URL || ""}${assetPath}`;
}
